import { StorageBackend } from '@openid/appauth';

/**
 * SessionStorage backend for @openid/appauth
 * Stores OAuth state in sessionStorage instead of localStorage
 */
export class SessionStorageBackend implements StorageBackend {
  getItem(name: string): Promise<string | null> {
    try {
      return Promise.resolve(sessionStorage.getItem(name));
    } catch (error) {
      console.error('Error reading from sessionStorage:', error);
      return Promise.resolve(null);
    }
  }

  removeItem(name: string): Promise<void> {
    try {
      sessionStorage.removeItem(name);
    } catch (error) {
      console.error('Error removing from sessionStorage:', error);
    }
    return Promise.resolve();
  }

  clear(): Promise<void> {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error('Error clearing sessionStorage:', error);
    }
    return Promise.resolve();
  }

  setItem(name: string, value: string): Promise<void> {
    try {
      sessionStorage.setItem(name, value);
    } catch (error) {
      console.error('Error writing to sessionStorage:', error);
    }
    return Promise.resolve();
  }
}
